import { ref as e } from "vue";
const o = e(), t = e(), p = () => ({
  selectedExampleKey: o,
  operationId: t
});
export {
  p as useExampleStore
};
